import {
  Anchor,
  Button,
  InfoModal,
  Input,
  Toast,
  CopyClipboardSVG,
} from "@newsela/angelou";
import PropTypes from "prop-types";

import globalToasterRef from "@/base/globalToasterRef";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import {
  copyButtonCss,
  copyButtonIconCss,
  copyLabelCss,
  copyUnderInputCss,
  fieldWrapperCss,
  modalContentWrapperCss,
  modalFooterCss,
  modalRootCss,
  modalscrollableBodyCss,
  sectionDividerCss,
} from "./ClassroomInvitationModal.style";

const propTypes = {
  /**
   * Pass a classroom object returned from a call to the Classroom API.
   */
  classroom: PropTypes.object,
  /**
   * Props passed directly to the InfoModal component. See the Angelou InfoModal for more information.
   */
  classroomInvitationModalProps: PropTypes.object,
  /**
   * Props passed directly to the Button in the top right corner of the modal. See the Angelou Button for more information.
   */
  closeButtonProps: PropTypes.object,
};

const EVENT_TOAST_SUCCESS_COPIED = {
  showIcon: true,
  statusColor: Toast.statusColor.primary,
  children: "Copied to clipboard",
};

const ClassroomInvitationModal = ({
  classroom,
  classroomInvitationModalProps,
  closeButtonProps,
}) => {
  const sharedButtonProps = {
    flavor: Button.flavors.polarMuted,
    icon: {
      SvgComponent: CopyClipboardSVG,
    },
    __cssFor: {
      root: copyButtonCss,
      Icon: copyButtonIconCss,
    },
  };

  const quickjoinLink = `${MONOLITH_ORIGIN}/quickjoin/#/${classroom?.class_code}`;

  const onClickCopy = (text) => {
    navigator.clipboard.writeText(text);
    globalToasterRef.current.displayToast(EVENT_TOAST_SUCCESS_COPIED);
  };

  return (
    <InfoModal
      labelId="InviteStudents"
      title={`Invite your students to ${classroom?.name}`}
      __cssFor={{
        root: modalRootCss,
        modalContentWrapper: modalContentWrapperCss,
        scrollableBody: modalscrollableBodyCss,
        footer: modalFooterCss,
      }}
      closeButtonProps={closeButtonProps}
      {...classroomInvitationModalProps}
    >
      <div css={fieldWrapperCss}>
        <Input
          label="Share class link"
          value={quickjoinLink}
          __cssFor={{
            label: copyLabelCss,
            underInput: copyUnderInputCss,
          }}
          disabled
        />
        <Button
          ariaProps={{
            "aria-label": "Copy class link to clipboard",
          }}
          onClick={() => onClickCopy(quickjoinLink)}
          {...sharedButtonProps}
        />
      </div>
      <div css={sectionDividerCss}>
        <strong>OR</strong>
        <hr />
      </div>
      <div css={fieldWrapperCss}>
        <Input
          label="Share class code"
          value={classroom?.class_code}
          __cssFor={{
            label: copyLabelCss,
            underInput: copyUnderInputCss,
          }}
          disabled
        />
        <Button
          ariaProps={{
            "aria-label": "Copy class code to clipboard",
          }}
          onClick={() => onClickCopy(classroom?.class_code)}
          {...sharedButtonProps}
        />
      </div>
      <span>
        For step-by-step instructions, print and share the&nbsp;
        <Anchor
          href={`${MONOLITH_ORIGIN}/people/classrooms/${classroom?.id}/quickstart`}
          isInline
        >
          {classroom?.name} Quick Start Guide
        </Anchor>
      </span>
    </InfoModal>
  );
};

ClassroomInvitationModal.propTypes = propTypes;
export default ClassroomInvitationModal;
